import React, {useRef, useEffect, useState} from 'react';
import { ForceGraph2D } from "react-force-graph";
import useResizeAware from 'react-resize-aware';
import axios from 'axios';
import {ReactComponent as EtherscanLogo} from './resource/etherscan.svg';
import { Modal } from "./Modal"
import { IoSearch } from "react-icons/io5";

function LoadingSpinner(){
    return <div className='m-auto'>
            <div className='bg-black w-5 h-5 animate-spin'></div>
          </div>
  }

function TruncateAddress(address){
    if (address && address.slice(-4) === ".eth"){
        return address
    } else{
        return address.slice(0, 4)+"..."+address.slice(-4)
    }
  }

  function WeiToEth(wei){
    return Math.round(Number(wei)/(10**14))/10000
  }
  
function AddNodeAndLink(target, props, nodes, setNodes, links, setLinks, balanceAverage, setBalanceAverage, name){
    let address = props[0]
    if(name && name.slice(-4) === ".eth"){
            address = name
    }
    const from = WeiToEth(props[1].from)
    const to = WeiToEth(props[1].to)
    if(nodes.some(node => node.id.toLowerCase() === address)){
        alert("Node exist");
        if(links.some(link => link.source.id.toLowerCase() === address && link.target.id.toLowerCase() === address)){
            return
        } else{
            let linksToAdd = []
            if(to > 0){
                linksToAdd.push({source: target, target: address, value: to})
            }
            if(from > 0){
                linksToAdd.push({source: address, target: target, value: from})
            }
            setLinks(links.concat(linksToAdd))
        }
    } else{
        axios.get('https://us-central1-dddyor.cloudfunctions.net/getBalance?address='+address)
        .then(response => {
            if (response.data.status === "1")
            {
                let balance = 0
                balance = WeiToEth(response.data.balance)
                if(balance < 100 && balance > 0.01){
                    setBalanceAverage((balanceAverage*nodes.length+ balance)/nodes.length)
                } 
                setNodes([...nodes,{id: address, balance: balance, index: nodes.length}])
                //TODO: add links more carefully
                let linksToAdd = []
                if(to > 0){
                    linksToAdd.push({source: target, target: address, value: to})
                }
                if(from > 0){
                    linksToAdd.push({source: address, target: target, value: from})
                }
                setLinks(links.concat(linksToAdd))
            }
        }).catch(e => {
            console.log(e)
        });
    }
    
}

function Transaction({parentProps, tx}){
    const [name, setName] = useState(null);
    const [txDisplayClass, setTxDispalyClass] = useState("basis-3/5 overflow-x-hidden")
    const [buttonClassName, setButtonClassName] = useState(null)
    const exist = parentProps.nodes.some(node => node.id.toLowerCase() === tx[0] || node.id.toLowerCase() === name)
    const [lookupInProgress, setLookupInProgress] = useState(null) 

    useEffect(() => {
        if(exist && !buttonClassName){
            setButtonClassName("text-red-500")
        }
    },[exist, buttonClassName, name]);

    function handleLookup(address){
        setLookupInProgress(true)
        axios.get('https://us-central1-dddyor.cloudfunctions.net/addressLookup?address='+address)
        .then(response =>{
            if (response.data.status === 1)
            {
                if(response.data.type === "address"){
                    alert("No lookup result, just a simple EOA")
                    setLookupInProgress(false)
                } else{
                    setName(response.data.result)
                    if(response.data.type === "ens"){
                        alert("ENS found")
                        setTxDispalyClass(txDisplayClass + " text-sky-700")
                    } else{
                        alert("This address is a contract")
                        setTxDispalyClass(txDisplayClass + " text-red-700")
                    }
                    setLookupInProgress(false)
                }
            } else{
                alert("Address lookup Failed")
                setLookupInProgress(false)
            }
        }).catch(e => {
            alert("Address lookup Failed")
            setLookupInProgress(false)
            console.warn(e)
        })
    }

    
    return <div key={tx[0]} className='relative py-2'>
                <button onClick={() => AddNodeAndLink(parentProps.result.address.toLowerCase(),tx,parentProps.nodes,parentProps.setNodes, 
                                                      parentProps.links,parentProps.setLinks, parentProps.balanceAverage, parentProps.setBalanceAverage,
                                                      name)}
                        className={'absolute mx-2 w-5 rounded-full border border-black ' + buttonClassName}> + </button>
                <div className='pl-10 flex flex-1 grid grid-cols-4'>
                    <div className='col-span-2'>
                        <div className='flex'>
                            <div className={txDisplayClass}>
                                {name ? name :TruncateAddress(tx[0])}
                            </div>
                            <div className='basis-1/5 px-2 m-auto mx-0'>
                                <EtherscanLogo className='w-5 h-5 cursor-pointer' onClick={()=> window.open("https://etherscan.io/address/"+tx[0], "_blank")}/>
                            </div>
                            <div className='basis-1/5 cursor-pointer' onClick={() => handleLookup(tx[0])}>
                                {lookupInProgress? <LoadingSpinner></LoadingSpinner>:<IoSearch size={"1.25rem"} className={"h-full"}/>}
                            </div>
                        </div>
                    </div>
                    <div className='col-span-1 text-[#e74c3c]'> {WeiToEth(tx[1].to)} </div>
                    <div className='col-span-1 text-[#27ae60]'> {WeiToEth(tx[1].from)} </div>
                </div>
            </div>
}

function TrasactionList(props){

    const txArray = Object.entries(props.result.transactions);
    const sortedTx = txArray.sort((a,b) => 
                        (a[1].from+a[1].to < b[1].from+b[1].to ? 1 : -1)
                    )
    let txList = []
    for (let i=0; i < sortedTx.length; i++){
        txList.push(<Transaction parentProps={props} tx={sortedTx[i]}></Transaction>)
    }

    return <div className='relative col-span-2 lg:col-span-1 mb-5 mr-5 rounded-md border border-black overflow-y-auto'>
                <div className='px-5 py-5 flex-1 grid grid-cols-4'>
                    <h1 className='col-span-3'>
                        <div className='flex'>
                        {TruncateAddress(props.result.address.toLowerCase())}
                        <EtherscanLogo className='w-5 h-5 ml-3 cursor-pointer' onClick={()=> window.open("https://etherscan.io/address/"+props.result.address.toLowerCase(), "_blank")}/>
                        </div>
                    </h1>
                    <h1 className='col-span-1'>
                            Ξ{WeiToEth(props.result.balance)}
                    </h1>
                </div> 
                <div className='pl-10 flex flex-1 grid grid-cols-4 '>
                    <div className='col-span-2'> Address</div>
                    <div className='col-span-1 text-[#e74c3c]'> To </div>
                    <div className='col-span-1 text-[#27ae60]'> From </div>
                </div>
                <div className='py-1 border-b border-black w-full'></div>
                <div>
                    {txList}
                </div>
            </div>
}


function Graph(props) {
    const targetRef = useRef();
    const [resizeListener, sizes] = useResizeAware();
  
    const forceRef = useRef(null);
    useEffect(() => {
      forceRef.current.d3Force("charge").strength(-400);
    });

    const [result, setResult] = useState(props.result);

    const [nodes, setNodes] = useState([{id: props.result.address.toLowerCase(), balance: WeiToEth(props.result.balance), index: 0}]);
    const [links, setLinks] = useState([]);
    const [balanceAverage, setBalanceAverage] = useState(WeiToEth(props.result.balance) > 100 ? 100:WeiToEth(props.result.balance))

    /*var data = {
      nodes: [{ id: "0x0000001", balance: 10, index: 0},
              { id: "0x0000002", balance: 1, index: 1},
              { id: "0x0000003", balance: 3, index: 2},
              { id: "0x0000004", balance: 6, index: 3}
            ],
      links: [
        { source: "0x0000001", target: "0x0000002", value: 2},
        { source: "0x0000002", target: "0x0000001", value: 3},
        { source: "0x0000002", target: "0x0000003", value: 8 },
        { source: "0x0000004", target: "0x0000003", value: 10 },
        { source: "0x0000001", target: "0x0000003", value: 6 },
        { source: "0x0000004", target: "0x0000001", value: 6 },
      ]
    };*/

    let data ={
        nodes: nodes,
        links: links
    }
  
    function searchNewAddress(address){
        props.setModalData({
            title: "",
            content: <LoadingSpinner></LoadingSpinner>,
            action: ""
        })
        axios.get('https://us-central1-dddyor.cloudfunctions.net/getBalanceAndTransactions?address='+address)
        .then(response => {
            setResult(response.data.result)
            if (response.data.status === "1")
            {
                setResult(response.data)
                props.setShowModal(false)
            } else {
                alert("Failed to search this address: " + address)
                props.setShowModal(false)
            }
        }).catch(e => {
            console.log(e)
        });
    }

    function handleNodeClick(node){
        props.setModalData({
            title: node.id,
            content: "Do you want to search this address?",
            action: <div>
                        <button onClick={()=>searchNewAddress(node.id)} className='w-1/5 py-3 rounded-lg border border-black hover:border-b-2 hover:border-r-2'>Yes</button>
                        <button onClick={()=>props.setShowModal(false)} className='ml-3 w-1/5 py-3 rounded-lg border border-black hover:border-b-2 hover:border-r-2'>No</button>
                    </div>
        })
        props.setShowModal(true)
    }
  
    function nodePaint({id, balance, x, y}, ctx, globalScale){
      ctx.beginPath(); 
      let r=(balance/balanceAverage)*10
      let nodeColor = "#D6DBDF"
      if(balance>100){
          r = 10
          nodeColor = "#3498DB"
      }
      if(balance<0.01){
        r = 2
        nodeColor = "#FDEDEC"
      }
      ctx.arc(x, y, r, 0, 2 * Math.PI, false); 
      
      ctx.fillStyle = nodeColor;
      ctx.fill(); 
      
      ctx.beginPath(); 
      ctx.arc(x, y, r, 0, 2 * Math.PI, false); 
      let borderColor = "#566573"
      ctx.strokeStyle = borderColor;
      ctx.stroke();
  
      ctx.beginPath();
      ctx.fillStyle = "#000000";
      ctx.font = "100"
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      let nameTag = TruncateAddress(id);
      if(balance>100){
        nameTag = nameTag+" 🐳"
      }
      if(balance<0.001){
        nameTag = nameTag+" 🦐"
      }
      ctx.fillText(nameTag, x, y)
    }
  
    function linkPaint(link, ctx, globalScale){
      let l = Math.hypot(link.source.x-link.target.x, link.source.y-link.target.y)
      let ux = (link.target.x-link.source.x)/l
      let uy = (link.target.y-link.source.y)/l
      let w = (link.value/balanceAverage)*2
      if(link.value/balanceAverage > 20){
          w = 20
      }
      if(link.value/balanceAverage < 0.1){
        w = 1
      }
      let vx = ux*Math.cos(Math.PI/2)-uy*Math.sin(Math.PI/2)
      let vy = ux*Math.sin(Math.PI/2)+uy*Math.cos(Math.PI/2)
  
      if (link.source.x && link.target.x){
        ctx.beginPath();
        var grad= ctx.createLinearGradient(link.source.x+vx*w/2, link.source.y+vy*w/2, link.target.x+vx*w/2, link.target.y+vy*w/2);
        if(link.value/balanceAverage > 20){
            grad.addColorStop(0, "#8C00FF");
            grad.addColorStop(1, "#FFE400");
        } else{
            grad.addColorStop(0, "#E74C3C");
            grad.addColorStop(1, "#27AE60");
        }
        ctx.strokeStyle = grad;
        ctx.lineWidth = w;
        ctx.moveTo(link.source.x+vx*w/2, link.source.y+vy*w/2);
        ctx.lineTo(link.target.x+vx*w/2, link.target.y+vy*w/2);
        ctx.stroke();
  
        ctx.beginPath();
        ctx.fillStyle = "#FFFFFF";
        let X = (link.source.x+link.target.x+vx*w)/2
        let Y = (link.source.y+link.target.y+vy*w)/2
        
        ctx.moveTo(X+ux*w/2, Y+uy*w/2);
        ctx.lineTo(X+(ux*Math.cos(Math.PI*2/3)-uy*Math.sin(Math.PI*2/3))*w/2, Y+(ux*Math.sin(Math.PI*2/3)+uy*Math.cos(Math.PI*2/3))*w/2);
        ctx.lineTo(X+(ux*Math.cos(Math.PI*4/3)-uy*Math.sin(Math.PI*4/3))*w/2, Y+(ux*Math.sin(Math.PI*4/3)+uy*Math.cos(Math.PI*4/3))*w/2);
        ctx.fill()
      }
    }
  
  
    return <div className='flex flex-col flex-1 min-h-0'>
                {props.showModal && <Modal setShowModal={props.setShowModal} modalData={props.modalData}></Modal>}
                <div className='grid grid-cols-4 h-full'>
                    <div
                    className='relative col-span-2 lg:col-span-3 mx-5 mb-5 rounded-md border border-black' 
                    ref={targetRef}>
                        {resizeListener}
                        <ForceGraph2D
                        graphData={data}
                        nodeLabel="balance"
                        nodeCanvasObject={(node, ctx, globalScale) => nodePaint(node, ctx, globalScale)}
                        linkLabel="value"
                        linkCanvasObject={(link, ctx, globalScale) => linkPaint(link, ctx, globalScale)}
                        nodeRelSize={7}
                        enablePointerInteraction={true}
                        linkHoverPrecision={1}
                        onNodeClick={(node)=> handleNodeClick(node)}
                        ref={forceRef}
                        width={sizes.width}
                        height={sizes.height}
                        />
                    </div>
                        {result && <TrasactionList result = {result} nodes={nodes} setNodes={setNodes} links={links} setLinks={setLinks} 
                                        balanceAverage={balanceAverage} setBalanceAverage={setBalanceAverage}></TrasactionList>}
                    </div> 
            </div>
  }

export { Graph, LoadingSpinner};
